import { noop } from '@aloft/toolkit-shared';

import { createContext } from 'react';

export const CheckoutStepsContext = createContext({
  step: 0,
  prevStep: noop,
  nextStep: noop,
});
